import { RouterModule, Routes } from '@angular/router';
import {HomeComponent} from './home/home.component';
import {LoginComponent} from './login/login.component';
import {AuthGuard} from './services/auth-guard.service';
import {ScannerComponent} from './scanner/scanner.component';
import {AllComponent} from './all/all.component';
import {GradoComponent} from './grado/grado.component';
import { FamilyComponent } from './family/family.component';

/* ///-------------------
---------- ROUTES --------
----------------------// */

const APP_ROUTES: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'scanner',
    component: ScannerComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'all',
    component: AllComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'grado/:id',
    component: GradoComponent,
  },
  {
    path: 'family/:id',
    component: FamilyComponent,
  },
  {
    path: '',
    component: LoginComponent,
  }
  /*,

  { path: '**', component: PageNotFoundComponent }*/
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES, { useHash: true });
